// import dJSON from 'dirty-json';
// import '../node_modules/@lottiefiles/lottie-player/dist/lottie-player';

import './js/base/base-start';
import './js/global';

// modules - core
import './modules/core/accordion/module';

// modules
import './modules/theme/category-cards/module';
import './modules/theme/message-cards/module';
import './modules/theme/information-banner/module';
import './modules/theme/icon-cards/module';
import './modules/theme/ink-and-toner-finder/module';
import './modules/theme/diagonal-cards/module';
import './modules/theme/brands-grid/module';
import './modules/theme/hero-slider/module';
import './modules/theme/hero-grid/module';
import './modules/evox/merch-slider/module';
import './modules/theme/hero-static/module';
import './modules/theme/cat-box/module';
import './modules/theme/c2a/module';
import './modules/theme/detail-cards/module';
import './modules/theme/section-title/module';
import './modules/theme/horizontal-grid/module';
import './modules/evox/custom-contact/module';
import './modules/theme/count-up/module';
import './modules/theme/image-slider/module';
import './modules/theme/tabbed-forms/module';

// layouts
import './layouts/visual-glossary/layout';

// leave me last
import './js/base/base-end';
